import { SettingsGroup, SettingsPageFrame } from '@eluve/blocks';
import { AppGrantsSettings } from '@eluve/frontend-feature-user-settings';

export const AppGrantsSettingsPage: React.FC = () => (
  <SettingsPageFrame title="App Grants">
    <SettingsGroup
      title="Authorized agents"
      description="Agents you have authorized to act on your behalf. Revoking forces the agent to ask for consent again before it can run."
    >
      <AppGrantsSettings />
    </SettingsGroup>
  </SettingsPageFrame>
);
